import React, { useEffect } from "react";
import TourFilter, { SHORT_BY_FILTER } from "./TourFilter";
import { clearTourList } from "./tourSlice";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import TourInquiryModel from "./TourInquiryModel";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { formatIndianNumber } from "../../_helpers/formatUtils";
// import Select from "react-select";
import Modal from "../../components/modal/Modal";
import FullLoading from "../../components/spinner/FullLoading";
import MainHomeBanner from "../../assets/images/kashmir-banner.png";
import { Tooltip } from "react-tooltip";
import { FaPersonCirclePlus } from "react-icons/fa6";

const TourList: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const Pathname = location.pathname?.split("/")[2];
  const SectorName = location.state?.SectorName;
  const SectorType = location.state?.SectorType;
  const params = useParams();
  const SectorURL = params?.SectorURL;
  const loading = useAppSelector((state) => state.tour.loading);
  const formLoading = useAppSelector((state) => state.tour.formLoading);
  const TourList = useAppSelector((state) => state.tour.TourList);
  const FilterTourDetails = useAppSelector(
    (state) => state.tour.FilterTourDetails
  );
  const [showModel, setShowModel] = React.useState(false);
  const [activeTour, setActiveTour] = React.useState({});

  useEffect(() => {
    return () => {
      dispatch(clearTourList());
    };
  }, []);

  const toggleFilter = () => {
    const filterSec = document.querySelector(".filter-section-main") as any;
    filterSec?.classList.add("menu-active");
  };
  const handleTourDetails = (tour: any) => {
    navigate(
      `/tour/package/${tour?.TourURL}/`
      //   , {
      //   state: {
      //     TourID: tour?.ID,
      //     RateType: tour?.Ratetype,
      //     NoOfNights: `${tour?.NoOfNights}`,
      //     RoomTypeID: tour?.RoomTypeID,
      //   },
      // }
    );
  };

  const formik: any = useFormik({
    initialValues: FilterTourDetails,
    onSubmit: () => {},
  });

  // const handleSortChange = (selectedOption: any) => {
  //   formik.setFieldValue("OrderBy", selectedOption);
  // };

  return (
    <>
      {<FullLoading loading={loading || formLoading} />}
      <Modal
        isOpen={showModel}
        onClose={() => setShowModel(false)}
        title={"Book This Tour"}
      >
        <TourInquiryModel setClose={setShowModel} data={activeTour} />
      </Modal>
      <div className="banner">
        <img
          className="banner-pic"
          src={
            SectorURL
              ? TourList && TourList?.length > 0
                ? TourList[0]?.BannerImage
                : MainHomeBanner
              : MainHomeBanner
          }
          alt="Sector Banner Image"
        />
        <div className="container">
          <h1>
            <h2 className="text-white d-inline m-0">Tour Packages</h2> <br />
            Tour List
          </h1>
        </div>
      </div>
      <div className="tour-listing padd-50">
        <form
          className="tab-content"
          id="myTabContent"
          onSubmit={(e) => formik.handleSubmit(e)}
        >
          <div className="container">
            <div className="column-main">
              <div className="row">
                <div className="col-lg-3 col-md-12 ">
                  <TourFilter formik={formik} />
                </div>
                <div className="col-lg-9 col-md-12">
                  <div className="column d-block">
                    <div className="toolbar">
                      <span className="modes-label">
                        <strong>{TourList?.length}</strong> Trips found
                      </span>
                      <div className="field flex-wrap">
                        <label htmlFor="">Sort by :</label>
                        {/* <select name="" id="">
                          <option value="">Popular</option>
                        </select> */}
                        <select
                          name="OrderBy"
                          value={formik.values.OrderBy}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // className={
                          //   formik.touched.billing_state_id &&
                          //   formik.errors.billing_state_id
                          //     ? "error-border"
                          //     : ""
                          // }
                        >
                          {/* <option value="">Select State</option> */}
                          {SHORT_BY_FILTER?.map((e) => (
                            <option key={e?.value} value={e?.value}>
                              {e?.label}
                            </option>
                          ))}
                        </select>
                        {/* <Select
                          className="selection-field"
                          options={SHORT_BY_FILTER}
                          onChange={handleSortChange}
                          value={
                            formik.values.OrderBy
                              ? SHORT_BY_FILTER.find(
                                  (item) => item.value === formik.values.OrderBy
                                )
                              : null
                          }
                        /> */}
                      </div>
                    </div>
                    <div className="row">
                      {TourList?.map((tour: any, index: number) => (
                        <div className="col-xl-4 col-md-6">
                          <div className="popular-card radius-10">
                            <a
                              href=""
                              onClick={() => {
                                handleTourDetails(tour);
                              }}
                              className="popular-card-pic img-effect"
                            >
                              <img
                                src={
                                  tour?.TourImage || "/images/NoImageFound.png"
                                }
                                alt=""
                              />
                            </a>
                            <div className="popular-card-content">
                              <div className="card-label">
                                <span className="card-label">
                                  {tour?.NoOfDays || 0} Days |{" "}
                                  {tour?.NoOfNights || 0} Nights
                                </span>
                                <span className="border-label">
                                  {tour?.TourCode || "-"}
                                </span>
                                {/* <span className="border-label">
                                  {tour?.code}
                                </span> */}
                              </div>
                              <h5
                                style={{
                                  borderBottom: "1px solid lightgray",
                                  paddingBottom: "10px",
                                }}
                              >
                                <a
                                  href=""
                                  onClick={(e: any) => {
                                    e.preventDefault();
                                    handleTourDetails(tour);
                                  }}
                                >
                                  {tour?.TourName}
                                </a>
                              </h5>
                              <div
                                className="short-desc-2 mb-2"
                                dangerouslySetInnerHTML={{
                                  __html: tour?.ShortDescription,
                                }}
                              />
                              {/* <span className="card-location">
                                {tour?.ShortDescription}
                              </span> */}
                              <div className="price-box">
                                <div className="price">
                                  <span
                                    className="cursor-pointer fs-6"
                                    data-tooltip-id={`inclusion-tooltip-${index}`}
                                    data-tooltip-html={
                                      // tour?.ShortDescription || ""
                                      ` <ul>
                                      ${
                                        tour?.toufacility &&
                                        tour?.toufacility?.length > 0
                                          ? tour.toufacility
                                              .map(
                                                (facilities: any) =>
                                                  `<li style="white-space:nowrap;">• ${facilities?.Name}</li>`
                                              )
                                              .join("")
                                          : ""
                                      }
                                     </ul>`
                                    }
                                  >
                                    <FaPersonCirclePlus /> Facilities
                                  </span>
                                  <img src="/images/info.png" alt="" />{" "}
                                  <Tooltip
                                    id={`inclusion-tooltip-${index}`}
                                    place="top"
                                    style={{
                                      maxWidth: "300px",
                                      whiteSpace: "normal",
                                      zIndex: 9999,
                                      fontSize: "12px",
                                      background: "white",
                                      boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                                    }}
                                  />
                                </div>
                                <div className="price text-right">
                                  Starting from{" "}
                                  <span>
                                    {tour?.Rate
                                      ? new Intl.NumberFormat("en-IN", {
                                          style: "currency",
                                          currency: "INR",
                                        }).format(tour?.Rate)
                                      : "0"}
                                  </span>
                                  {tour?.Ratetype}
                                </div>
                              </div>
                              <div className="product-btn">
                                <a
                                  className="btn border-btn"
                                  href=""
                                  onClick={() => {
                                    handleTourDetails(tour);
                                  }}
                                >
                                  More Details
                                </a>
                                <a
                                  className="btn gradiant-btn"
                                  href=""
                                  onClick={(e: any) => {
                                    e.preventDefault();
                                    setShowModel(true);
                                    setActiveTour(tour);
                                  }}
                                >
                                  Book Now
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    {/* <div className="pagination padd-40">
                      <a className="active" href="#">
                        1
                      </a>
                      <a href="#">2</a>
                      <a href="#">3</a>
                      <a href="#">
                        <img src="/images/right-pagination.png" alt="" />
                        <img
                          className="hover-pic"
                          src="/images/right-white-pagination.png"
                          alt=""
                        />
                      </a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      {false && (
        <>
          <div className="list-banner-section">
            <div className="list-banner-pic">
              <img
                src={
                  TourList && TourList?.length > 0
                    ? TourList[0]?.BannerImage
                      ? TourList[0]?.BannerImage
                      : "/images/LIST-BANNER.jpg"
                    : "/images/LIST-BANNER.jpg"
                }
                alt="Banner Image"
              />
            </div>
            <div className="container" style={{ position: "relative" }}>
              <div className="list-banner-body">
                {false && (
                  <div className="breadcrum">
                    <a className="breadcrum-home" href="javascript:;">
                      {SectorType}{" "}
                      <img src="/images/bredcrums.png" alt="Breadcrum Image" />{" "}
                    </a>
                    <a href="javascript:;">{SectorName || Pathname}</a>
                  </div>
                )}
                <h3>
                  {SectorName} selected in <span>{SectorType}</span>
                </h3>
                <p>
                  Showing{" "}
                  <span>
                    {TourList && TourList?.length > 0
                      ? TourList[0]?.TotalCountData
                      : 0}{" "}
                  </span>
                  Tour Packages
                </p>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="list-page">
              <div className="row pt-3">
                <div className="col-lg-3 col-md-12 col-sm-12 position-relation">
                  <button className="filter-btn" onClick={toggleFilter}>
                    <span className="text-dark"> short by</span>
                  </button>
                  <TourFilter formik={formik} />
                </div>
                <div className="col-lg-9 col-md-12 col-sm-12">
                  {TourList && TourList?.length > 0
                    ? TourList.map((tour: any, index: number) => {
                        return (
                          <div className="list-post" key={index}>
                            <div className="list-post-pic">
                              <img
                                src={
                                  tour?.TourImage ||
                                  "/images/newimages/NoImageFound.png"
                                }
                                alt="Tour Image"
                              />
                            </div>
                            <div className="list-post-body">
                              <div className="selling-city">
                                <div className="selling-city-half">
                                  <img
                                    src="/images/clock.png"
                                    alt="Clock Image"
                                  />{" "}
                                  {tour?.NoOfDays || 0} Days
                                </div>
                                <div className="selling-city-half selling-city-half-2">
                                  <img
                                    src="/images/calendra.png"
                                    alt="Calender Image"
                                  />{" "}
                                  {tour?.NoOfNights || 0} Nights
                                </div>
                              </div>
                              <a className="list-heading" href="javascript:;">
                                <div className="kashmir-section-head">
                                  <h4
                                    onClick={() => {
                                      handleTourDetails(tour);
                                    }}
                                  >
                                    {tour?.TourName}
                                  </h4>
                                </div>
                              </a>
                              <p>
                                {tour?.TourCities}{" "}
                                <a
                                  className="link"
                                  dangerouslySetInnerHTML={{
                                    __html: tour?.ShortDescription,
                                  }}
                                />
                              </p>
                              <div className="inclusion">
                                {tour?.toufacility &&
                                tour?.toufacility?.length > 0 ? (
                                  <div className="inclusion-left">
                                    <span>Inclusions:</span>
                                    <ul>
                                      {tour?.toufacility?.map(
                                        (facilities: any) => (
                                          <li>
                                            <img
                                              src={facilities?.Image}
                                              alt={facilities?.Name || "Logo"}
                                            />
                                            {facilities?.Name}
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  </div>
                                ) : (
                                  <div className="inclusion-left"></div>
                                )}
                                <div className="submit-section">
                                  {+tour?.Rate > 1 && (
                                    <>
                                      {" "}
                                      <div className=" fw-bold fs-6 text-center">
                                        Starting From
                                      </div>
                                      <div className="Total mb-2">
                                        <i
                                          className="fa fa-inr fs-5"
                                          style={{
                                            fontStyle: "normal",
                                            color: "#F05A28",
                                          }}
                                        >
                                          ₹
                                        </i>{" "}
                                        <span className="price">
                                          {tour?.Rate
                                            ? formatIndianNumber(+tour?.Rate)
                                            : 0}
                                          <code>*</code>
                                        </span>
                                      </div>
                                      <div
                                        className="text-center"
                                        style={{ fontSize: 12 }}
                                      >
                                        {tour?.Ratetype}
                                      </div>
                                    </>
                                  )}
                                  <div className="btn-list mt-2">
                                    <span
                                      className="btn"
                                      onClick={() => {
                                        handleTourDetails(tour);
                                      }}
                                    >
                                      View
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    : !loading &&
                      !formLoading && (
                        <div className="text-center">
                          <img
                            src="/images/newimages/nodata.jpg"
                            style={{
                              maxWidth: 450,
                            }}
                          />
                        </div>
                      )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default TourList;
